import React from "react";

interface Props {
  title: string;
  subtitle?: string;
  onClose: () => void;
  children: React.ReactNode;
  footer?: React.ReactNode;
  className?: string;
}

export default function ModalShell({
  title,
  subtitle,
  onClose,
  children,
  footer,
  className,
}: Props) {
  return (
    <div className="cg-modal-backdrop" onClick={onClose}>
      <div
        className={`cg-modal${className ? ` ${className}` : ""}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="cg-modal-head">
          <div className="cg-modal-head-text">
            <h3>{title}</h3>
            {subtitle && <p className="cg-modal-subtitle">{subtitle}</p>}
          </div>
          <button className="cg-modal-close" onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>
        <div className="cg-modal-body">{children}</div>
        {footer && <div className="cg-modal-foot">{footer}</div>}
      </div>
    </div>
  );
}
